export default __webpack_public_path__ + "static/media/Message type.279d7b43.svg";